
import AdminProvider from "./components/Admin/AdminProvider/AdminProvider";
import Background from "./components/Admin/Bacground/Background";
import BG from "./components/Admin/Bacground/BG";
import Layout from "./Layout";

function App() {
  return (
    <>
      <AdminProvider>
        <BG />
        <Layout />
      </AdminProvider>
    </>
  );
}

export default App;